/*
------------------------------------------------------------
- Archivo : client/src/components/Dashboard.js
- Proyecto: CB30
- Propósito:
- Dashboard común para todos los usuarios de CB30.
-
- Contenido:
-   • Aviso para completar Person cuando corresponda.
-   • Listado de encuestas disponibles/completadas.
-   • Información general de CB30.
-
- El acceso a opciones administrativas se controla mediante
- el menú dinámico y los permisos, no mediante un Dashboard
- diferente.
------------------------------------------------------------
*/

import React, { Component } from "react";
import { graphql } from "react-apollo";

// Query
import query from "../queries/fetchUser";

// Components
import IsValidatedUser from "./User/IsValidatedUser";
import SurveyList from "./Survey/consumer/SurveyList";
import Welcome from "./Content/Welcome";

class Dashboard extends Component {
  render() {
    if (this.props.data.loading) {
      return <div>Loading...</div>;
    }

    const user = this.props.data.user;

    if (!user) {
      return null;
    }

    return (
      <React.Fragment>
      <IsValidatedUser userPerson={user.person} />

      <SurveyList />

      {(!user.person || !user.person.documento_de_identidad) && <Welcome />}
      </React.Fragment>
    );
  }
}

export default graphql(query)(Dashboard);


// WEBPACK FOOTER //
// ./src/components/Dashboard.js